import { FC } from 'react'
import { Box, Typography, Grid, styled } from '@mui/material'
import Card from './Card'
import { LinkMeta } from '@client-hub/shared/react/hooks/links'

const SubHeading = styled(Typography)({
  fontSize: '1.875rem',
  margin: '3.125rem 0 1rem',
})

export type Props = {
  title: string
  cards: LinkMeta[]
}

const CardsSection: FC<Props> = ({ title, cards }) => (
  <Box>
    <SubHeading variant="h2">{title}</SubHeading>
    <Grid container spacing={3}>
      {cards.map((card) => (
        <Card key={card.label} {...card} />
      ))}
    </Grid>
  </Box>
)

export default CardsSection
